import { internalFetch } from '../utils/fetchHelper';

export interface IWorkReportInfo {
  fileName: string;
  creationDate: string;
  blobUrl: string;
}

// TODO: Item shape TBD — update when BE finalizes the response
export interface IGeneratedReport {
  fileName: string;
  creationDate: string;
  blobUrl: string;
}

export interface IGeneratedReportsResponse {
  items: IGeneratedReport[];
}

export const checkWorkReport = async (
  abortController: AbortController,
  workId: number
): Promise<IWorkReportInfo | null> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/checkWorkReport?workId=${workId}`,
    'GET',
    abortController
  );
};

export const generateWorkReport = async (
  abortController: AbortController,
  workId: number,
  reportTemplateId: number
): Promise<IWorkReportInfo> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/generateWorkReport?workId=${workId}&reportTemplateId=${reportTemplateId}`,
    'POST',
    abortController
  );
};

export const downloadWorkReport = async (
  abortController: AbortController,
  url: string
): Promise<Response> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/downloadWorkReport?url=${encodeURIComponent(url)}`,
    'GET',
    abortController,
    undefined,
    true
  );
};

export const getAllWorkReports = async (
  abortController: AbortController,
  workId: number
): Promise<IGeneratedReportsResponse> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/workReports?workId=${workId}&pageNo=1&pageSize=100`,
    'GET',
    abortController
  );
};
